import ccreq from '../ccnet/ccreq'

// /homePage/recommendPsyProject
export function portalList(){ return ccreq.get(`/api/homePage/recommendPsyProject`, {}) }